import {
  Box,
  Button,
  Checkbox,
  Grid,
  IconButton,
  MenuItem,
  Select,
  TextField,
  Tooltip,
  Typography,
} from "@mui/material";
import { useEffect, useMemo, useRef, useState } from "react";
import { fAlertToast, getStatusStyle } from "../../Utility/Utilitys";
import {
  ISTCRA_Confirm_GetRow,
  ISTCRA_REVERSE,
  ISTCRB_Approve_Update,
} from "../../Server/ApiV2";
import moment from "moment";
import {
  StockSetupChangeApproveRo,
  StockSetupChangeRequestRo,
  vRdxUserInfo,
} from "../../Redux/roStore";
import { useDispatch, useSelector } from "react-redux";
import "./StockSetupChangeApprove.css";
import { DataGridPro, gridRowIdsSelector, useGridApiRef } from "@mui/x-data-grid-pro";

import { Head_Set } from "./SliceStockSetupChangeApprove";
import { confirmAlert } from "react-confirm-alert";
import DownloadOutlinedIcon from "@mui/icons-material/DownloadOutlined";
import PrintOutlinedIcon from "@mui/icons-material/PrintOutlined";

const ApproveModal = ({ rejectTypeArr, fonLoad, handleClose, type }) => {
  const rowRef = useRef([]);
  const dispatch = useDispatch();
  const [detailData, setDetailData] = useState([]);
  const apiRef = useGridApiRef();
  const isEditAllowed = useSelector(
    (state) => state.SliceDB.value.DBKernObj.EDIT_STOCKSETUP_VAL_IN_APP_MODE.Val
  );

  const HeadObject = StockSetupChangeApproveRo();
  const transObj = useSelector(
    (state) => state.SliceStockSetupChangeApprove.value.Head
  );

  const vRdxKernObj = useSelector((state) => state.SliceDB.value.DBKernObj);

  const visible = vRdxKernObj?.STOCK_SETUP_MAX_FIELD?.Val === "N";

  const handleLoadBtn = async () => {
    if (HeadObject?.Head?.A_Transid === "") {
      fAlertToast("INFO", "Trans ID should not be empty");
      return;
    }
    const StockResponse = await ISTCRA_Confirm_GetRow({
      B_Transid: HeadObject?.Head?.A_Transid || "",
    });
    if (StockResponse?.status === 200)
      setDetailData(StockResponse?.data?.ResultSet || []);
  };

  const handleFieldEdit = (params, value, fieldName, parser = (v) => v) => {
    const row = rowRef.current;
    const currentRowIndex = row?.findIndex(
      (r) => r.B_Srno === params.row?.B_Srno
    );
    const updatedRow = {
      ...row[currentRowIndex],
      [fieldName]: parser(value),
    };
    if (["B_Appr_MinStockDays", "B_Appr_SafetyStockDays"].includes(fieldName)) {
      updatedRow[fieldName] = Number(value);
      const min = Number(updatedRow.B_Appr_MinStockDays) || 0;
      const safety = Number(updatedRow.B_Appr_SafetyStockDays) || 0;
      updatedRow.B_Appr_MaxStockDays = min + safety;
    }
    const newRowData = [...row];
    newRowData[currentRowIndex] = updatedRow;
    setDetailData(newRowData);
  };

  const fSave = async (isApproved, name , isRejected ) => {
    const vRdxUserInfoObj = vRdxUserInfo();

    const obj = {
      B_TransId: HeadObject?.Head?.A_Transid || "",
      UserCd: vRdxUserInfoObj?.UserID || "",
      isApproved: isApproved,
      isRejected:isRejected,
      LineItems: detailData,
      Type: type,
    };

    const StockResponse = await ISTCRB_Approve_Update(obj);
    if (StockResponse?.status === 200) {
      fAlertToast("SUCCESS", `${name} Successfully`);
      dispatch(
        Head_Set({
          ...transObj,
          ApproveStatus: name === "Approved" ? "POST" : transObj.ApproveStatus,
        })
      );
      await fonLoad();
        if (isApproved || isRejected){
      handleClose();
        }
      if (name === "Saved") await handleLoadBtn();
    }
  };

  const rejectSave = async () => {
    const vRdxUserInfoObj = vRdxUserInfo();

    var obj = {
      B_TransId: HeadObject?.Head?.A_Transid || "",
      UserCd: vRdxUserInfoObj?.UserID || "",
      isApproved: false,
      isRejected: true,
      LineItems: detailData,
      Type: type,
    };
    const rejectRes = await ISTCRB_Approve_Update(obj);
    if (rejectRes?.status === 200) {
      fAlertToast("SUCCESS", "Rejected Successfully");
      dispatch(
        Head_Set({
          ...transObj,
          ApproveStatus: "REJECT",
        })
      );
      await fonLoad();
      handleClose();
    } else {
      fAlertToast(
        "FAILED",
        `Reject Failed: ${rejectRes?.response?.data?.error || "Unknown error"}`
      );
    }
  };
  const reverseSave = async () => {
    const HeadObject = StockSetupChangeRequestRo();
    const obj = {
      A_TransId: HeadObject?.Head?.A_Transid || 0,
      UserCd: vRdxUserInfo()?.UserID,
      Type: type,
    };
    const reverseRes = await ISTCRA_REVERSE(obj);
    if (reverseRes?.status === 200) {
      const obj = {
        ...transObj,
      };
      if (type === "PM") obj.A_Status_PM = "ENTER";
      else if (type === "CM") obj.A_Status_CM = "ENTER";
      else {
        obj.ApproveStatus = "ENTER";
      }
      dispatch(Head_Set(obj));
      fAlertToast("SUCCESS", "Reversed Successfully");
      await fonLoad();
      handleClose();
    } else {
      fAlertToast("FAILED", "Reverse Failed");
    }
  };
  const yesNoOptions = [
    { Uid: "Y", Name: "Yes" },
    { Uid: "N", Name: "No" },
  ];

  const activeOptions = [
    { Uid: "Y", Name: "Active" },
    { Uid: "N", Name: "Inactive" },
  ];

  const getOldCellClass = (oldValue, newValue) =>
    oldValue !== newValue ? "cell-old" : "";
  const getNewCellClass = (oldValue, newValue) =>
    oldValue !== newValue ? "cell-new" : "";
  const getApproveCellClass = (oldValue, newValue) =>
    oldValue !== newValue ? "cell-approve" : "";

  const baseColumns = [
    { field: "Srno", headerName: "Sr No", width: 75, hide: true },
    { field: "TransId", headerName: "Trans ID", width: 60, hide: true },
    { field: "B_Itmcd", headerName: "Item Code", width: 80 },
    {
      field: "ItmName",
      headerName: "Item Name",
      width: 210,
      renderCell: (params) => (
        <div
          style={{
            whiteSpace: "normal",
            wordWrap: "break-word",
            overflowWrap: "break-word",
            lineHeight: "1.4em",
          }}
        >
          {params.value}
        </div>
      ),
    },
    // DisContinued
    {
      field: "Old_DisContinued",
      headerName: "Old",
      width: 40,
      minWidth: 40,
      align: "center",
      cellClassName: (params) =>
        getOldCellClass(
          params.row.Old_DisContinued,
          params.row.New_DisContinued
        ),
    },
    {
      field: "New_DisContinued",
      headerName: "New",
      width: 40,
      minWidth: 40,
      align: "center",
      cellClassName: (params) =>
        getNewCellClass(
          params.row.Old_DisContinued,
          params.row.New_DisContinued
        ),
    },
    {
      field: "Appr_DisContinued",
      headerName: "App",
      width: 60,
      align: "center",
      cellClassName: (params) =>
        getApproveCellClass(
          params.row.Old_DisContinued,
          params.row.New_DisContinued
        ),
      renderCell: (params) => {
        if (params.row.Old_DisContinued !== params.row.New_DisContinued) {
          return (
            <div style={{ width: "100%" }}>
              <Select
                disabled={isEditAllowed === "Y" ? false : true}
                value={params.row.Appr_DisContinued}
                onChange={(e) =>
                  handleFieldEdit(params, e.target.value, "Appr_DisContinued")
                }
                inputProps={{
                  name: `B_Appr_DisContinued-${params.row.Srno}`,
                }}
                displayEmpty
                fullWidth
                onClick={(e) => e.stopPropagation()}
                onKeyDown={(e) => e.stopPropagation()}
              >
                {yesNoOptions.map((opt) => (
                  <MenuItem key={opt.Uid} value={opt.Uid}>
                    {opt.Uid}
                  </MenuItem>
                ))}
              </Select>
            </div>
          );
        }
      },
    },
    {
      field: "DisContinue_ReasonName",
      headerName: "Reason",
      width: 120,
      minWidth: 60,
      align: "center",
    },
    // ItActive
    {
      field: "Old_ItActive",
      headerName: "Old",
      width: 40,
      minWidth: 40,
      align: "center",
      cellClassName: (params) =>
        getOldCellClass(params.row.Old_ItActive, params.row.New_ItActive),
    },
    {
      field: "New_ItActive",
      headerName: "New",
      width: 40,
      minWidth: 40,
      align: "center",
      cellClassName: (params) =>
        getNewCellClass(params.row.Old_ItActive, params.row.New_ItActive),
    },

    {
      field: "Appr_ItActive",
      headerName: "App",
      width: 60,
      align: "center",
      cellClassName: (params) =>
        getApproveCellClass(params.row.Old_ItActive, params.row.New_ItActive),
      renderCell: (params) => {
        if (params.row.Old_ItActive !== params.row.New_ItActive) {
          return (
            <div style={{ width: "100%" }}>
              <Select
                disabled={isEditAllowed === "Y" ? false : true}
                value={params.row.Appr_ItActive}
                onChange={(e) =>
                  handleFieldEdit(params, e.target.value, "Appr_ItActive")
                }
                onKeyDown={(e) => {
                  e.stopPropagation();
                  if (e.key === "Enter") {
                    e.preventDefault();
                    const currentRowIndex = detailData.findIndex(
                      (r) => r.B_Srno === params.row.Srno
                    );
                    const nextRow = detailData[currentRowIndex + 1];
                    if (nextRow) {
                      const nextInput = document.querySelector(
                        `input[name="B_Appr_ItActive-${nextRow.B_Srno}"]`
                      );
                      if (nextInput) nextInput.focus();
                    }
                  }
                }}
                displayEmpty
                inputProps={{
                  name: `B_Appr_ItActive-${params.row.Srno}`,
                }}
                fullWidth
                onClick={(e) => e.stopPropagation()}
              >
                {activeOptions.map((opt) => (
                  <MenuItem key={opt.Uid} value={opt.Uid}>
                    {opt.Uid}
                  </MenuItem>
                ))}
              </Select>
            </div>
          );
        }
      },
    },
    {
      field: "Active_ReasonName",
      headerName: "Reason",
      width: 120,
      minWidth: 60,
      align: "center",
    },

    // DCDisCon

    // ShelfQty
    {
      field: "Old_ShelfQty",
      headerName: "Old",
      width: 40,
      align: "center",
      type: "number",
      headerAlign: "center",
      cellClassName: (params) =>
        getOldCellClass(params.row.Old_ShelfQty, params.row.New_ShelfQty),
    },
    {
      field: "New_ShelfQty",
      headerName: "New",
      width: 40,
      align: "center",
      type: "number",
      headerAlign: "center",
      cellClassName: (params) =>
        getNewCellClass(params.row.Old_ShelfQty, params.row.New_ShelfQty),
    },
    {
      field: "Appr_ShelfQty",
      headerName: "App",
      width: 56,
      headerAlign: "center",
      align: "center",
      cellClassName: (params) =>
        getApproveCellClass(params.row.Old_ShelfQty, params.row.New_ShelfQty),
      renderCell: (params) => {
        if (params.row.Old_ShelfQty !== params.row.New_ShelfQty) {
          return (
            <div
              style={{ width: "100%" }}
              onMouseDownCapture={(e) => e.stopPropagation()}
              onClick={(e) => e.stopPropagation()}
              onFocus={(e) => e.stopPropagation()}
            >
              <TextField
                disabled={isEditAllowed === "Y" ? false : true}
                type="number"
                value={params.value}
                onChange={(e) =>
                  handleFieldEdit(params, e.target.value, "Appr_ShelfQty")
                }
                onBlur={(e) => e.stopPropagation()}
                inputProps={{ name: `Appr_ShelfQty-${params.row.B_Itmcd}` }}
                sx={{
                  backgroundColor:
                    params.row.Old_ShelfQty !== params.row.New_ShelfQty
                      ? "#C8B6FF"
                      : "",
                  "& input": { textAlign: "center" },
                }}
              />
            </div>
          );
        }
      },
    },
    // ShelfQty2
    {
      field: "Old_ShelfQty2",
      headerName: "Old",
      width: 40,
      align: "center",
      type: "number",
      headerAlign: "center",
      cellClassName: (params) =>
        getOldCellClass(params.row.Old_ShelfQty2, params.row.New_ShelfQty2),
    },
    {
      field: "New_ShelfQty2",
      headerName: "New",
      width: 40,
      align: "center",
      type: "number",
      headerAlign: "center",
      cellClassName: (params) =>
        getNewCellClass(params.row.Old_ShelfQty2, params.row.New_ShelfQty2),
    },
    {
      field: "Appr_ShelfQty2",
      headerName: "App",
      width: 56,
      headerAlign: "center",
      align: "center",
      cellClassName: (params) =>
        getApproveCellClass(params.row.Old_ShelfQty2, params.row.New_ShelfQty2),
      renderCell: (params) => {
        if (params.row.Old_ShelfQty2 !== params.row.New_ShelfQty2) {
          return (
            <div
              style={{ width: "100%" }}
              onMouseDownCapture={(e) => e.stopPropagation()}
              onClick={(e) => e.stopPropagation()}
              onFocus={(e) => e.stopPropagation()}
            >
              <TextField
                disabled={isEditAllowed === "Y" ? false : true}
                type="number"
                value={params.value}
                onChange={(e) =>
                  handleFieldEdit(params, e.target.value, "Appr_ShelfQty2")
                }
                onBlur={(e) => e.stopPropagation()}
                inputProps={{ name: `Appr_ShelfQty2-${params.row.B_Itmcd}` }}
                sx={{
                  backgroundColor:
                    params.row.Old_ShelfQty2 !== params.row.New_ShelfQty2
                      ? "#C8B6FF"
                      : "",
                  "& input": { textAlign: "center" },
                }}
              />
            </div>
          );
        }
      },
    },
    {
      field: "ShelfQty_ReasonName",
      headerName: "Reason",
      width: 120,
      minWidth: 60,
      align: "center",
    },
     {
                                    field: "B_Status",
                                    headerName: "Reject",
                                    width: 53,
                                    align: "center",
                                    sortable: false,
                                    filterable: false,
                                    disableColumnMenu: true,
                                    renderCell: (params) => {
                                      const checked = Boolean(Number(params.row?.B_Status));
                                      return (
                                        <Checkbox
                                          size="small"
                                          checked={checked}
                                          onChange={(e) =>
                                            handleFieldEdit(params, e.target.checked, "B_Status")
                                          }
                                        />
                                      );
                                    },
                                  },
    {
      field: "B_RejectDetail",
      headerName: "Reject Type",
      width: 120,
      renderCell: (params) => (
        <div style={{ width: "100%" }}>
          <Select
            value={params.row.B_RejectDetail || ""}
            onChange={(e) =>
              handleFieldEdit(params, e.target.value, "B_RejectDetail")
            }
            size="small"
            displayEmpty
            fullWidth
            //disabled={isActionButtonDisabled}
            onClick={(e) => e.stopPropagation()}
            onKeyDown={(e) => e.stopPropagation()}
          >
            {rejectTypeArr?.map((opt, index) => (
              <MenuItem key={opt.UId + index} value={opt.UId}>
                {opt.Name1}
              </MenuItem>
            ))}
          </Select>
        </div>
      ),
    },

    {
      field: "B_ReJectNarration",
      headerName: "Reject Narration",
      width: 200,
      renderCell: (params) => {
        return (
          <EditableRejectNarration
            value={params.row.B_ReJectNarration}
            onSave={(newValue) =>
              handleFieldEdit(params, newValue, "B_ReJectNarration")
            }
            //  disabled={isActionButtonDisabled}
          />
        );
      },
    },
  ];

  const maxFieldColumns = [
    {
      field: "Old_DCDisCon",
      headerName: "Old",
      width: 40,
      minWidth: 40,
      align: "center",
      cellClassName: (params) =>
        getOldCellClass(params.row.Old_DCDisCon, params.row.New_DCDisCon),
    },
    {
      field: "New_DCDisCon",
      headerName: "New",
      width: 40,
      minWidth: 40,
      align: "center",
      cellClassName: (params) =>
        getNewCellClass(params.row.Old_DCDisCon, params.row.New_DCDisCon),
    },
    {
      field: "Discontinued",
      headerName: "New",
      width: 40,
      minWidth: 40,
      align: "center",
      cellClassName: (params) =>
        getNewCellClass(params.row.Old_DCDisCon, params.row.New_DCDisCon),
    },

    {
      field: "Appr_DCDisCon",
      headerName: "App",
      width: 60,
      align: "center",
      cellClassName: (params) =>
        getApproveCellClass(params.row.Old_DCDisCon, params.row.New_DCDisCon),
      renderCell: (params) => {
        if (params.row.Old_DCDisCon !== params.row.New_DCDisCon) {
          return (
            <div
              style={{ width: "100%" }}
              // onMouseDownCapture={(e) => e.stopPropagation()} // MAIN FIX
              // onClick={(e) => e.stopPropagation()} // Optional safety
            >
              <Select
                disabled={isEditAllowed === "Y" ? false : true}
                value={params.row.Appr_DCDisCon}
                onChange={(e) =>
                  handleFieldEdit(params, e.target.value, "Appr_DCDisCon")
                }
                inputProps={{
                  name: `Appr_DCDisCon-${params.row.Srno}`,
                }}
                displayEmpty
                fullWidth
                onClick={(e) => e.stopPropagation()}
                onKeyDown={(e) => e.stopPropagation()}
              >
                {yesNoOptions.map((opt) => (
                  <MenuItem key={opt.Uid} value={opt.Uid}>
                    {opt.Uid}
                  </MenuItem>
                ))}
              </Select>
            </div>
          );
        }
      },
    },
    {
      field: "DisContinue_ReasonName",
      headerName: "Reason",
      width: 40,
      minWidth: 40,
      align: "center",
    },
    {
      field: "Old_CNTRLPUR",
      headerName: "Old",
      width: 40,
      minWidth: 40,
      align: "center",
      cellClassName: (params) =>
        getOldCellClass(params.row.Old_CNTRLPUR, params.row.New_CNTRLPUR),
    },
    {
      field: "New_CNTRLPUR",
      headerName: "New",
      width: 40,
      minWidth: 40,
      align: "center",
      cellClassName: (params) =>
        getNewCellClass(params.row.Old_CNTRLPUR, params.row.New_CNTRLPUR),
    },
    {
      field: "Appr_CNTRLPUR",
      headerName: "App",
      width: 60,
      align: "center",
      cellClassName: (params) =>
        getApproveCellClass(params.row.Old_CNTRLPUR, params.row.New_CNTRLPUR),
      renderCell: (params) => {
        if (params.row.Old_CNTRLPUR !== params.row.New_CNTRLPUR) {
          return (
            <div
              style={{ width: "100%" }}
              // onMouseDownCapture={(e) => e.stopPropagation()} // MAIN FIX
              // onClick={(e) => e.stopPropagation()} // Optional safety
            >
              <Select
                disabled={isEditAllowed === "Y" ? false : true}
                value={params.row.Appr_CNTRLPUR}
                onChange={(e) =>
                  handleFieldEdit(params, e.target.value, "Appr_CNTRLPUR")
                }
                inputProps={{
                  name: `Appr_CNTRLPUR-${params.row.Srno}`,
                }}
                displayEmpty
                fullWidth
                onClick={(e) => e.stopPropagation()}
                onKeyDown={(e) => e.stopPropagation()}
              >
                {yesNoOptions.map((opt) => (
                  <MenuItem key={opt.Uid} value={opt.Uid}>
                    {opt.Uid}
                  </MenuItem>
                ))}
              </Select>
            </div>
          );
        }
      },
    },

    // LCLPur
    {
      field: "Old_LCLPur",
      headerName: "Old",
      width: 40,
      minWidth: 40,
      align: "center",
      cellClassName: (params) =>
        getOldCellClass(params.row.Old_LCLPur, params.row.New_LCLPur),
    },
    {
      field: "New_LCLPur",
      headerName: "New",
      width: 40,
      minWidth: 40,
      align: "center",
      cellClassName: (params) =>
        getNewCellClass(params.row.Old_LCLPur, params.row.New_LCLPur),
    },
    {
      field: "Appr_LCLPur",
      headerName: "App",
      width: 60,
      align: "center",
      cellClassName: (params) =>
        getApproveCellClass(params.row.Old_LCLPur, params.row.New_LCLPur),
      renderCell: (params) => {
        if (params.row.Old_LCLPur !== params.row.New_LCLPur) {
          return (
            <div
              style={{ width: "100%" }}
              // onMouseDownCapture={(e) => e.stopPropagation()} // MAIN FIX
              // onClick={(e) => e.stopPropagation()} // Optional safety
            >
              <Select
                disabled={isEditAllowed === "Y" ? false : true}
                value={params.row.Appr_LCLPur}
                onChange={(e) =>
                  handleFieldEdit(params, e.target.value, "Appr_LCLPur")
                }
                inputProps={{
                  name: `Appr_LCLPur-${params.row.Srno}`,
                }}
                displayEmpty
                fullWidth
                onClick={(e) => e.stopPropagation()}
                onKeyDown={(e) => e.stopPropagation()}
              >
                {yesNoOptions.map((opt) => (
                  <MenuItem key={opt.Uid} value={opt.Uid}>
                    {opt.Uid}
                  </MenuItem>
                ))}
              </Select>
            </div>
          );
        }
      },
    },
    // MinStockDays
    {
      field: "Old_MinStockDays",
      headerName: "Old",
      width: 40,
      align: "center",
      type: "number",
      headerAlign: "center",
      cellClassName: (params) =>
        getOldCellClass(
          params.row.Old_MinStockDays,
          params.row.New_MinStockDays
        ),
    },
    {
      field: "New_MinStockDays",
      headerName: "New",
      width: 40,
      align: "center",
      type: "number",
      headerAlign: "center",
      cellClassName: (params) =>
        getNewCellClass(
          params.row.Old_MinStockDays,
          params.row.New_MinStockDays
        ),
    },
    {
      field: "Appr_MinStockDays",
      headerName: "App",
      width: 56,
      headerAlign: "center",
      align: "center",
      cellClassName: (params) =>
        getApproveCellClass(
          params.row.Old_MinStockDays,
          params.row.New_MinStockDays
        ),
      renderCell: (params) => {
        if (params.row.Old_MinStockDays !== params.row.New_MinStockDays) {
          return (
            <div
              style={{ width: "100%" }}
              onMouseDownCapture={(e) => e.stopPropagation()}
              onClick={(e) => e.stopPropagation()}
              onFocus={(e) => e.stopPropagation()}
            >
              <TextField
                type="number"
                disabled={isEditAllowed === "Y" ? false : true}
                value={params.value}
                onChange={(e) =>
                  handleFieldEdit(params, e.target.value, "Appr_MinStockDays")
                }
                onBlur={(e) => e.stopPropagation()}
                inputProps={{
                  name: `Appr_MinStockDays-${params.row.B_Itmcd}`,
                }}
                sx={{
                  backgroundColor:
                    params.row.Old_MinStockDays !== params.row.New_MinStockDays
                      ? "#C8B6FF"
                      : "",
                  "& input": { textAlign: "center" },
                }}
              />
            </div>
          );
        }
      },
    },

    // SafetyStockDays
    {
      field: "Old_SafetyStockDays",
      headerName: "Old",
      width: 40,
      align: "center",
      type: "number",
      headerAlign: "center",
      cellClassName: (params) =>
        getOldCellClass(
          params.row.Old_SafetyStockDays,
          params.row.New_SafetyStockDays
        ),
    },
    {
      field: "New_SafetyStockDays",
      headerName: "New",
      width: 40,
      align: "center",
      type: "number",
      headerAlign: "center",
      cellClassName: (params) =>
        getNewCellClass(
          params.row.Old_SafetyStockDays,
          params.row.New_SafetyStockDays
        ),
    },
    {
      field: "Appr_SafetyStockDays",
      headerName: "App",
      width: 56,
      headerAlign: "center",
      align: "center",
      cellClassName: (params) =>
        getApproveCellClass(
          params.row.Old_SafetyStockDays,
          params.row.New_SafetyStockDays
        ),
      renderCell: (params) => {
        if (params.row.Old_SafetyStockDays !== params.row.New_SafetyStockDays) {
          return (
            <div
              style={{ width: "100%" }}
              onMouseDownCapture={(e) => e.stopPropagation()}
              onClick={(e) => e.stopPropagation()}
              onFocus={(e) => e.stopPropagation()}
            >
              <TextField
                type="number"
                disabled={isEditAllowed === "Y" ? false : true}
                value={params.value}
                onBlur={(e) => e.stopPropagation()}
                onChange={(e) =>
                  handleFieldEdit(
                    params,
                    e.target.value,
                    "Appr_SafetyStockDays"
                  )
                }
                inputProps={{
                  name: `Appr_SafetyStockDays-${params.row.B_Itmcd}`,
                }}
                sx={{
                  backgroundColor:
                    params.row.Old_SafetyStockDays !==
                    params.row.New_SafetyStockDays
                      ? "#C8B6FF"
                      : "",
                  "& input": { textAlign: "center" },
                }}
              />
            </div>
          );
        }
      },
    },
    // MaxStockDays
    {
      field: "Old_MaxStockDays",
      headerName: "Old ",
      width: 40,
      align: "center",
      type: "number",
      headerAlign: "center",
      cellClassName: (params) =>
        getOldCellClass(
          params.row.Old_MaxStockDays,
          params.row.New_MaxStockDays
        ),
    },
    {
      field: "New_MaxStockDays",
      headerName: "New ",
      width: 40,
      align: "center",
      type: "number",
      headerAlign: "center",
      cellClassName: (params) =>
        getNewCellClass(
          params.row.Old_MaxStockDays,
          params.row.New_MaxStockDays
        ),
    },
    {
      field: "Appr_MaxStockDays",
      headerName: "App ",
      width: 56,
      align: "center",
      type: "number",
      headerAlign: "center",
      cellClassName: (params) =>
        getApproveCellClass(
          params.row.Old_MaxStockDays,
          params.row.New_MaxStockDays
        ),
    },
  ];

  const deptColumn = {
    field: "Department",
    headerName: "Department",
    width: 100,
  };

  const allColumns = useMemo(() => {
    const merged = !visible
      ? [...baseColumns, ...maxFieldColumns]
      : [...baseColumns];
    return [...merged, deptColumn];
  }, [visible]);

  const columnGroupingModel = [
    {
      groupId: "Discontinued",
      children: [
        { field: "Old_DisContinued" },
        { field: "New_DisContinued" },
        { field: "Appr_DisContinued" },
        { field: "DisContinue_ReasonName" },
      ],
    },
    {
      groupId: "Active",
      children: [
        { field: "Old_ItActive" },
        { field: "New_ItActive" },
        { field: "Appr_ItActive" },
        { field: "Active_ReasonName" },
      ],
    },
    {
      groupId: "DC Discontinued",
      children: [
        { field: "Old_DCDisCon" },
        { field: "New_DCDisCon" },
        { field: "Appr_DCDisCon" },
        { field: "DCDisCon_ReasonName" },
      ],
    },
    {
      groupId: "Central Purchase",
      children: [
        { field: "Old_CNTRLPUR" },
        { field: "New_CNTRLPUR" },
        { field: "Appr_CNTRLPUR" },
        { field: "CNTRLPUR_ReasonName" },
      ],
    },
    {
      groupId: "Local Purchase",
      children: [
        { field: "Old_LCLPur" },
        { field: "New_LCLPur" },
        { field: "Appr_LCLPur" },
        { field: "LCLPUR_ReasonName" },
      ],
    },
    {
      groupId: "Min.Stock Days",
      children: [
        { field: "Old_MinStockDays" },
        { field: "New_MinStockDays" },
        { field: "Appr_MinStockDays" },
      ],
    },
    {
      groupId: "Safety Stock Days",
      children: [
        { field: "Old_SafetyStockDays" },
        { field: "New_SafetyStockDays" },
        { field: "Appr_SafetyStockDays" },
      ],
    },
    {
      groupId: "Max.Stock Days",
      children: [
        { field: "Old_MaxStockDays" },
        { field: "New_MaxStockDays" },
        { field: "Appr_MaxStockDays" },
      ],
    },
    {
      groupId: "Max Shelf Qty",
      children: [
        { field: "Old_ShelfQty" },
        { field: "New_ShelfQty" },
        { field: "Appr_ShelfQty" },
      ],
    },
    {
      groupId: "Min Shelf Qty",
      children: [
        { field: "Old_ShelfQty2" },
        { field: "New_ShelfQty2" },
        { field: "Appr_ShelfQty2" },
      ],
    },
  ];

  useEffect(() => {
    handleLoadBtn();
  }, []);

  useEffect(() => {
    rowRef.current = detailData;
  }, [detailData]);

   const handleExport = () => {
  apiRef.current.exportDataAsCsv({
    getRowsToExport: ({ apiRef }) => gridRowIdsSelector(apiRef),
    includeHeaders: true,
    utf8WithBom: true,
  });
  };
  const handlePrint = () => {
    apiRef.current.exportDataAsPrint();
  };

  const isActionButtonDisabled = useMemo(() => {
    const status = HeadObject?.Head;
    if (type === "") {
      return (
        status?.ApproveStatus === "REJECT" || status?.ApproveStatus === "POST"
      );
    }
    if (type === "CM") {
      return status?.A_Status_CM === "POST" || status?.A_Status_CM === "REJECT";
    }
    if (type === "PM") {
      return status?.A_Status_PM === "POST" || status?.A_Status_PM === "REJECT";
    }
    return false;
  }, [type, HeadObject?.Head]);
  const shouldShowReverseButton = () => {
    const head = HeadObject?.Head;

    if (!head) return false;

    const aStatusPM = head.A_Status_PM?.toUpperCase();
    const aStatusCM = head.A_Status_CM?.toUpperCase();
    const aStatus = head.A_Status?.toUpperCase();
    const ApproveStatus = head.ApproveStatus?.toUpperCase();

    if (type === "") {
      return (
        aStatusPM === "REJECT" && aStatusCM === "POST" && aStatus !== "ENTER"
      );
    }

    if (type === "CM") {
      return (
        // ApproveStatus === "REJECT" &&
        aStatusPM === "REJECT" && aStatusCM === "POST"
      );
    }

    if (type === "PM") {
      return (
        ApproveStatus === "REJECT" &&
        aStatusPM === "POST" &&
        aStatusCM === "POST"
      );
    }

    return false;
  };
  return (
    <>
      {/* Header Info  */}
      <Grid
        container
        sx={{
          borderRadius: "12px",
          boxShadow: "0 2px 8px rgba(0, 0, 0, 0.15)",
          backgroundColor: "white",
          padding: "12px",
          marginTop: "12px !important",
        }}
      >
        {[
          { label: "Trans ID", value: HeadObject?.Head?.A_Transid },
          {
            label: "Date",
            value: moment(HeadObject?.Head?.A_Date).format("DD/MM/YYYY"),
          },
          { label: "Location Name", value: HeadObject?.Head?.Loc_Name },
          { label: "Narration", value: HeadObject?.Head?.A_Narration },
          {
            label: "Status",
            value: HeadObject?.Head?.A_Status,
            renderCell: (params) => {
              const style = getStatusStyle(params.value);
              return <span style={style}>{params.value}</span>;
            },
          },
          {
            label: "CM Status",
            value: HeadObject?.Head?.A_Status_CM,
            renderCell: (params) => {
              const style = getStatusStyle(params.value);
              return <span style={style}>{params.value}</span>;
            },
          },
          {
            label: "PM Status",
            value: HeadObject?.Head?.A_Status_PM,
            renderCell: (params) => {
              const style = getStatusStyle(params.value);
              return <span style={style}>{params.value}</span>;
            },
          },
          {
            label: "Confirm Status",
            value: HeadObject?.Head?.ApproveStatus,
            renderCell: (params) => {
              const style = getStatusStyle(params.value);
              return <span style={style}>{params.value}</span>;
            },
          },
          {
            label: "Created Date",
            value: moment(HeadObject?.Head?.CreatedDate).format("DD/MM/YYYY"),
          },
        ].map((item, idx) => (
          <Grid item xs={12} sm={4} md={4} key={idx}>
            <Grid container alignItems="center" spacing={1} wrap="nowrap">
              <Grid item xs={5.5}>
                <Typography
                  variant="body2"
                  fontWeight="bold"
                  color="#0d73bb"
                  sx={{
                    minWidth: "120px",
                    whiteSpace: "nowrap",
                    overflow: "hidden",
                    textOverflow: "ellipsis",
                  }}
                >
                  {item.label}
                </Typography>
              </Grid>
              <Grid item xs={6.5}>
                <Typography
                  variant="body2"
                  sx={{
                    whiteSpace: "nowrap",
                    overflow: "hidden",
                    textOverflow: "ellipsis",
                  }}
                >
                  {item.renderCell
                    ? item.renderCell({ value: item.value })
                    : item.value}
                </Typography>
              </Grid>
            </Grid>
          </Grid>
        ))}
        <Grid item xs={12}>
          <Box
            display="flex"
            justifyContent={"flex-end"}
            gap={1}
            flexWrap={"wrap"}
            mt={1}
          >
            <Button
              variant="contained"
              size="small"
              sx={{ textTransform: "capitalize" }}
              onClick={() => fSave(false, "Saved")}
              disabled={isActionButtonDisabled}
            >
              Save
            </Button>
            <Button
              variant="contained"
              size="small"
              sx={{ textTransform: "capitalize" }}
              onClick={() => {
                confirmAlert({
                  title: "Confirm Action",
                  message: `Are you sure you want to approve ?`,
                  buttons: [
                    {
                      label: "Yes",
                      onClick: () => {
                        fSave(true, "Approved");
                      },
                    },
                    {
                      label: "No",
                      onClick: () => {},
                    },
                  ],
                });
              }}
              disabled={isActionButtonDisabled}
            >
              Approve
            </Button>
            <Button
              variant="contained"
              color="error"
              size="small"
              sx={{ textTransform: "capitalize" }}
              onClick={() => {
                confirmAlert({
                  title: "Confirm Action",
                  message: `Are you sure you want to reject ?`,
                  buttons: [
                    {
                      label: "Yes",
                      onClick: () => {
                        rejectSave();
                      },
                    },
                    {
                      label: "No",
                      onClick: () => {},
                    },
                  ],
                });
              }}
              disabled={isActionButtonDisabled}
            >
              Reject
            </Button>{" "}
            {shouldShowReverseButton() && (
              <Button
                variant="contained"
                color="error"
                size="small"
                sx={{ textTransform: "capitalize" }}
                onClick={() => {
                  confirmAlert({
                    title: "Confirm Action",
                    message: "Are you sure you want to Reverse?",
                    buttons: [
                      {
                        label: "Yes",
                        onClick: () => {
                          reverseSave();
                        },
                      },
                      {
                        label: "No",
                        onClick: () => {},
                      },
                    ],
                  });
                }}
              >
                Reverse
              </Button>
            )}
            <Tooltip title="Export CSV">
              <IconButton color="primary" onClick={handleExport} size="small">
                <DownloadOutlinedIcon />
              </IconButton>
            </Tooltip>
            <Tooltip title="Print">
              <IconButton color="primary" onClick={handlePrint} size="small">
                <PrintOutlinedIcon />
              </IconButton>
            </Tooltip>
          </Box>
        </Grid>
      </Grid>
      {/* Data Grid */}
      <Box sx={{ height: { xs: "60vh", sm: "63vh", md: "65vh" }, mt: 1 }}>
        <DataGridPro
          apiRef={apiRef}
          rows={detailData}
          columns={allColumns}
          columnGroupingModel={columnGroupingModel}
          experimentalFeatures={{ columnGrouping: true }}
          getRowId={(row) => row.B_Srno}
          rowHeight={35}
          headerHeight={40}
          hideFooter
          getRowClassName={(params) => {
            const base =
              params.indexRelativeToCurrentPage % 2 === 0
                ? "mui-even-row"
                : "mui-odd-row";

            return Number(params.row?.B_Status) ? `${base} reject-row` : base;
          }}
          sx={{
            "& .MuiDataGrid-columnHeaderCheckbox .MuiCheckbox-root": {
              color: "#24292e",
            },
            "& .MuiDataGrid-columnHeaderCheckbox .MuiCheckbox-root.Mui-checked":
              {
                color: "#0298f5",
              },
            border: 1,
            borderColor: "primary.light",
            "& .MuiDataGrid-columnHeaders": {
              backgroundColor: "#0d73bb",
              color: "white",
            },
            "& .MuiDataGrid-cell": {
              padding: "0px 2px",
            },
            "& .MuiDataGrid-columnHeader": {
              whiteSpace: "normal",
              lineHeight: "1.2em",
              paddingTop: "8px",
              paddingBottom: "1px",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              textAlign: "center",
            },
            "& .MuiDataGrid-columnHeaderTitle": {
              whiteSpace: "normal",
              wordWrap: "break-word",
              fontSize: "11px", // Optional for better fit
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              textAlign: "center",
            },
            "& .MuiDataGrid-columnHeader--filledGroup .MuiDataGrid-columnHeaderTitleContainer":
              {
                textAlign: "center",
                justifyContent: "center",
              },
            "& .MuiDataGrid-row.reject-row": {
              backgroundColor: "#ffe5e5 !important",
            },
          }}
        />
      </Box>
    </>
  );
};
const EditableRejectNarration = ({ value: initialValue, onSave }) => {
  const [value, setValue] = useState(initialValue || "");

  useEffect(() => {
    setValue(initialValue || "");
  }, [initialValue]);

  const handleChange = (e) => {
    e.stopPropagation();
    setValue(e.target.value);
  };

  const handleBlur = (e) => {
    e.stopPropagation();
    onSave(value);
  };
  const handleKeyDown = (e) => {
    if (e.key === " ") {
      e.stopPropagation();
    }
    const blocked = [
      "ArrowLeft",
      "ArrowRight",
      "ArrowUp",
      "ArrowDown",
      "Home",
      "End",
      "PageUp",
      "PageDown",
    ];
    if (blocked.includes(e.key)) e.stopPropagation();
  };

  return (
    <div
      style={{ width: "100%" }}
      onMouseDownCapture={(e) => e.stopPropagation()}
      onClick={(e) => e.stopPropagation()}
      onFocus={(e) => e.stopPropagation()}
    >
      <TextField
        value={value}
        onChange={handleChange}
        onKeyDown={handleKeyDown}
        onBlur={handleBlur}
        size="small"
        multiline
        autoComplete="off"
        rows={2}
        fullWidth
        sx={{ "& textarea": { fontSize: "12px" } }}
      />
    </div>
  );
};
export default ApproveModal;
